<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->

<template>
    <transition name="fade">
        <div
            v-if="show"
            class="modal"
        >
            <div class="modal__dialog">
                <div class="modal__header">
                    <slot name="header">
                        {{ iframeTitle }}
                    </slot>
                    <button
                        type="button"
                        class="modal__close"
                        @click="closeModal()"
                    >
                        x
                    </button>
                </div>

                <div class="modal__body">
                    <iframe
                        id="quickViewIFrame"
                        class="gpfCls"
                        width="100%"
                        height="100%"
                        :src="quickview"
                        @load="load"
                    />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Modal',
    data() {
        return {
            show: true,
            iframeTitle: 'Loading...'
        };
    },
    computed: {
        quickview: {
            get() {
                return this.$store.state.quickview;
            }
        }
    },
    methods: {
        closeModal() {
            this.show = false;
            document.querySelector('body').classList.remove('overflow-hidden');
        },
        openModal() {
            this.show = true;
            document.querySelector('body').classList.add('overflow-hidden');
        },
        load() {
            var content = document.getElementById('quickViewIFrame').contentWindow;
            var doc = content.document;
            var jQuery = content.$;

            jQuery(doc).ajaxSuccess((event, xhr, settings) => {
                var url = window.Urls ? window.Urls.addProduct : jQuery('.add-to-cart-url').val();
                var reqUrl = settings.url && settings.url.split('?')[0];
                if (reqUrl === url) {
                    window.location.reload();
                }
            });
            this.iframeTitle = doc.title;
        }
    }
};
</script>

<style lang="scss" scoped>
.modal {
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    top: 5rem;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    display: flex;
    &__backdrop {
        background-color: rgba(0, 0, 0, 0.3);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
    }
    &__dialog {
        background-color: #ffffff;
        border: 0.1rem solid black;
        position: relative;
        width: 100%;
        top: 0rem;
        max-width: 56.25rem;
        height: 41.625rem;
        margin: 3.125rem auto;
        display: flex;
        flex-direction: column;
        border-radius: .3125rem;
        z-index: 2;
        @media screen and (max-width: 62rem) {
            width: 98%;
        }
    }
    &__close {
        width: 1.875rem;
        height: 1.875rem;
    }
    &__header {
        padding: 1.25rem 1.25rem .625rem;
        display: flex;
        align-items: flex-start;
        justify-content: end;
        background-color: #eee;
        border-bottom: .125rem solid #ccc;
    }
    &__body {
        overflow: auto;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        height: 37.5rem;
        margin-left: 1rem;
    }
    .gpfCls {
        border: 0rem;
    }
    &__footer {
        padding: .625rem 1.25rem 1.25rem;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
